// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpTaskmoniIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpTaskmoniIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpTaskmoniIconOutlined = function DrrpTaskmoniIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpTaskmoniIconOutlinedSvg
  }));
};

DrrpTaskmoniIconOutlined.displayName = 'DrrpTaskmoniIconOutlined';
export default React.forwardRef(DrrpTaskmoniIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpTaskmoniIconOutlined.js
// module id = 2590
// module chunks = 0